import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const probationaryPeriodExpirationDateFilterLabel = () => t({
    message: 'Probationary period expiration date',
    comment: 'Insights: Date signed date filter',
});
export function ProbationaryPeriodExpirationDateFilter() {
    return (<DateRangeFilter name="metadataDocumentProbationaryPeriodExpirationDate" label={probationaryPeriodExpirationDateFilterLabel()}/>);
}
